// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","mobileThreshold":"575px","container":"CollageTip_container__3ABNF"};